import axios from 'axios';
import {
  BED_ROOMS, BEDS_PER_ROOM,
  BEDS_PER_ROOM_GUEST, GUEST_BOOKED_IN, GUEST_BOOKED_OUT,
  GUEST_BOOKING,
} from '../../service/constants.service';
import {GlobalUtility} from '../../service/global-utility.service';

const  state = {
  guestBookings : [],
  guestBooking : {},

  newGuestBooking : {
    guest_id : '',
    booked_check_in : '',
    booked_check_out : '',
    floor_id : '',
    hotel_id : '',
    bed_id : '',
    room_id : '',
  },

  guestBedAvailable : [],
  guestBedOccupied : [],

};


const mutations = {
  set_guest_bookings : (state,params) =>{
    state.guestBookings = params;
  },

  set_guest_booked : (state,param) =>{
    state.guestBooking  = param;
  },

  set_create_guest_booked : (state,param) =>{
    state.newGuestBooking = {
      guest_id : '',
      booked_check_in : '',
      booked_check_out : '',
      floor_id : '',
      hotel_id : '',
      bed_id : '',
      room_id : '',
    };
  },

  //todo
  // set_update_guest_booked : (state,param) =>{},

  set_delete_guest_bookoed : (state,param) =>{
    let index = state.guestBookings.findIndex((index,key)=> index.id === param.id);
    state.guestBookings.splice(index,1);
  },

  set_guest_bed_available : (state,params) =>{
    state.guestBedAvailable = params ;
  },

  set_guest_bed_occupied : (state,params) =>{
    state.guestBedOccupied = params ;
  },

  set_null_guest_beds : (state) =>{
    state.guestBedAvailable = [];
    state.guestBedOccupied = [];
  },

};


const actions = {
  getAllGuestBooking({commit},params){
    return axios.get(GUEST_BOOKING,{params}).then((response)=>{
      commit('set_guest_bookings',response.data.data);
      commit('set_guest_booked_pagination',response.data);
      return true;

    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'Get All Guest Booking');
      return false;

    })
  },

  getGuestBookedDetail({commit},id){
    return axios.get(`${GUEST_BOOKING}/${id}`).then((response)=>{
      commit('set_guest_booked',response.data);
      return true;
    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'Get Guest Booked Details');
      return false;
    })
  },

  createNewGuestBooked({commit},params){
    return axios.post(GUEST_BOOKING,params).then((response)=>{
      commit('set_create_guest_booked',response)
      return true;
    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'Create Guest Booked');
      return false;
    });
  },

async  bedsPerRoomGuest({commit},params){
    console.log('this is bedPerRoomGuest',params);
    return await  axios.post(BEDS_PER_ROOM,params).then((response)=>{
      commit('set_guest_bed_available',response.data.available_beds);
      commit('set_guest_bed_occupied',response.data.occupied_beds);
      return true;
    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'Get Beds Per Room Guest');
      return false;
    });
  },


  setGuestBookedIn({commit},params){
    return axios.post(GUEST_BOOKED_IN,{id : params}).then((response)=>{
      console.log(response.data);
      return true;
    }).catch((error)=>{
      console.log(error.data);
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'SET BOOKED IN');
      return false;
    });
  },

  setGuestBookedOut({commit},params){
    return axios.post(GUEST_BOOKED_OUT,{id : params}).then((response)=>{
      console.log(response.data)
      return true;
    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'SET GUEST BOOKED OUT');
      return false;
    });
  },

  deleteGuestBooked({commit},params){
   return axios.delete(`${GUEST_BOOKING}/${params}`).then((response)=>{
     commit('set_delete_guest_bookoed',response.data);
     return true;
   }).catch((error)=>{
     GlobalUtility.failProgressBar();
     GlobalUtility.generateResponseMessage(error,'Delete Guest Booked');
     return false;
   });
  }
};

const getters = {
  guestBedAvailable : state => state.guestBedAvailable,
  guestBedOccupied : state => state.guestBedOccupied,
  guestBooking : state => state.guestBooking,
  guestBookings : state => state.guestBookings,
  newGuestBooking : state => state.newGuestBooking,

};

export default {state,actions,mutations,getters};


